import moment from 'moment'

exportUsersCsv.$inject = ['UserCSVHeaders']

export default function exportUsersCsv(headers) {
  return {
    restrict: 'A',
    scope: true,
    link: function(scope, elm, attrs) {
      scope.$watchCollection(attrs.users, function(users) {
        scope.users = users
        setAnchorAttributes(scope.users, scope.product, scope.domainName)
      })
      scope.$watch(attrs.product, function(product) {
        scope.product = product
        setAnchorAttributes(scope.users, scope.product, scope.domainName)
      })
      scope.$watchCollection(attrs.domainName, function(domainName) {
        scope.domainName = domainName
        setAnchorAttributes(scope.users, scope.product, scope.domainName)
      })

      function generateData(users, product) {
        return users.map(function(u) {
          var licenseAttr = ''
          if (product === 'toolkit') {
            licenseAttr = 'active_toolkit_license'
          }
          if (product === 'pathways') {
            licenseAttr = 'active_pathways_license'
          }
          return {
            uuid: u.uuid,
            name: u.name,
            email: u.email,
            title: u.title,
            school: (u.schools && u.schools.length > 0 && u.schools[0].name) || '',
            password: '',
            product: (u[licenseAttr] && product) || '',
            type: (u[licenseAttr] && u[licenseAttr].type) || '',
            sub_type: (u[licenseAttr] && u[licenseAttr].sub_type) || '',
            start_date: (u[licenseAttr] && u[licenseAttr].start_date_fmt) || '',
            end_date: (u[licenseAttr] && u[licenseAttr].end_date_fmt) || '',
            license_uuid: (u[licenseAttr] && u[licenseAttr].uuid) || '',
            tags: (u.tags && u.tags.join(',')) || '',
            sub_groups: Array.isArray(u.subgroup_names) && u.subgroup_names.length > 0 ? u.subgroup_names.join(',') : '',
            supergroups: Array.isArray(u.supergroups) && u.supergroups.length > 0 ? u.supergroups.join(',') : '',
            sso_external_id: u.sso_external_id || ''
          }
        })
      }

      // element should be an anchor
      function escapeField(fieldString) {
        // if there are commas, wrap in double quotes
        // if there are double quotes already, replace with ""
        if (fieldString.indexOf(',') > -1) {
          fieldString = fieldString.replace(/"/g, '""')
          fieldString = '"' + fieldString + '"'
        }
        return fieldString
      }
      function generateCSVString(data) {
        var fields = [
          'uuid',
          'name',
          'email',
          'title',
          'school',
          'password',
          'product',
          'type',
          'sub_type',
          'start_date',
          'end_date',
          'license_uuid',
          'tags',
          'sub_groups',
          'supergroups',
          'sso_external_id'
        ]
        var csvString = fields
          .map(function(f) {
            return escapeField(headers[f])
          })
          .join(',')
          .concat('\r\n')

        data.forEach(function(d) {
          csvString += fields
            .map(function(f) {
              return escapeField(d[f])
            })
            .join(',')
            .concat('\r\n')
        })

        return csvString
      }

      function setAnchorAttributes(users, product, domainName) {
        if (users && product && domainName) {
          // generate file name
          var filename =
            'export_' +
            domainName.toLowerCase().replaceAll(' ', '_') +
            '_' +
            product +
            '_' +
            moment(new Date()).format('YYYY-MM-DD') +
            '.csv'
          var csvString = generateCSVString(generateData(users, product))
          elm.attr('download', filename)
          elm.attr('href', 'data:attachment/csv,' + encodeURIComponent(csvString))
        }
      }
    }
  }
}
